/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.1.0
 * @since 1.0.0
 */

import styled from 'styled-components';

import { ILabelColor, LabelColor } from '../../../constants/labelColor';

export const TableLabelBlockStyled = styled.div.attrs({
    className: 'table__label-block',
})`
    display: flex;
    flex-direction: row;
`;

export const LabelCellStyled = styled.div.attrs({
    className: 'label-cell',
})<{ color: ILabelColor }>`
    padding-left: 16px;
    position: relative;
    
    &:before {
        position: absolute;
        top: 8px;
        left: 2px;
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        ${({ color }) => color ? `background-color:${LabelColor[color]};` : ''}
    }
`;
